const appVersion = (ctx, next) => {
  const { locals } = ctx;

  if (process.env.GIT_VERSION) {
    locals.appVersion = process.env.GIT_VERSION;
    return next();
  }

  if (!process.browser && !process.env.GIT_VERSION) {
    const child_process = require("child_process");
    locals.appVersion = child_process
      .execSync("git describe --always", { encoding: "utf8" })
      .trim();
  }

  return next();
};

export default appVersion;
